import classNames from 'classnames';

import { CoreGlobalNavigationFooterData } from 'src/types/components';

import ComplianceNav from 'components/BaseHelpers/Footer/ComplianceNav';
import FooterCard from 'components/BaseHelpers/Footer/FooterCard';
import PrimaryNav from 'components/BaseHelpers/Footer/PrimaryNav';
import SocialLinks from 'components/BaseHelpers/Footer/SocialLinks';
import Image from 'components/BaseHelpers/Image';
import Link from 'components/BaseHelpers/Link';
import RichText from 'components/BaseHelpers/RichText';
import Text from 'components/BaseHelpers/Text';

import styles from './CoreNavigationFooter.module.scss';

export type CoreNavigationFooterProps = CoreGlobalNavigationFooterData;

const CoreNavigationFooter = ({ fields }: CoreNavigationFooterProps) => {
  const { footerLogo, primaryNav, messageCard, complianceLinks, copyright } = fields;

  return (
    <footer className={styles.main}>
      <div className={classNames(styles.innerWrapper, 'container-large')}>
        <div className={styles['column--left']}>
          <div className={styles.innerColumn}>
            {footerLogo && (
              <Link
                href="/"
                className={classNames(styles.logoLink)}
                aria-label="Navigate to the homepage"
              >
                <Image
                  aria-label="StLukes college of health sciences"
                  className={styles.logo}
                  {...footerLogo}
                  fill
                />
              </Link>
            )}
            <RichText className={styles.subtitle} field={fields.location} />
          </div>
          <nav
            className={classNames(styles.innerColumn, styles.leftHandNavs)}
            aria-label="Footer Navigation"
          >
            <PrimaryNav navigationItems={primaryNav} className={styles.primaryNav} />
            <SocialLinks links={fields.socialMediaLinks} className={styles.socials} />
          </nav>
        </div>
        <div className={styles['column--right']}>
          <FooterCard className={styles.card} messageCard={messageCard} />
          <div className={styles.rightColumnBottomSection}>
            <ComplianceNav navigationItems={complianceLinks} />
            <div className={styles.noticeWrapper}>
              {!!copyright && (
                <p className={styles.noticeCopy}>
                  <Text field={copyright} />
                </p>
              )}
              <RichText
                className={styles.noticeCopy}
                styleType="sub-text"
                field={fields.givingDisclaimer}
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default CoreNavigationFooter;
